// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
	window.onload = function() {	
		scrollW();
		initDualCards();
		window.addEventListener('scroll', function(){
			scrollW();
			//scrollDownAction(60, 'scroll'); //function change logo on scroll
		})
	};

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.querySelectorAll('.form-module__field').length > 0){
		document.querySelectorAll('.form-module__field').forEach( field => {
			if(field.querySelector('input')){
				field.querySelector('input').addEventListener('focus',() =>{field.classList.add('focused')})
			}
			if(field.querySelector('select')){
				field.querySelector('select').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
			if(field.querySelector('textarea')){
				field.querySelector('textarea').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
		});
	}

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	if (window.innerWidth > 900) {

		const itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
		const navImages = document.querySelectorAll('.header__navimg img');
		const navContainer = document.querySelector('.header__navimg');

		function showImage(index) {
			navImages.forEach(img => img.classList.remove('active'));

			const image = document.querySelector(
				`.header__navimg img[data-navgo="${index}"]`
			);

			if (image) {
				navContainer.classList.remove('hidden');
				image.classList.add('active');
			}
		}

		itemsMenu.forEach((itemMenu, index) => {

			itemMenu.addEventListener('mouseenter', () => {
				showImage(index);
			});

			itemMenu.addEventListener('mouseleave', () => {

				const activeIndex = [...itemsMenu].findIndex(item =>
					item.querySelector('.privary-navigation__item .active')
				);

				if (activeIndex !== -1) {
					showImage(activeIndex);
				} else if (itemsMenu.length) {
					showImage(0);
				}

			});

		});

		const activeIndex = [...itemsMenu].findIndex(item =>
			item.querySelector('.privary-navigation__item .active')
		);

		if (activeIndex !== -1) {
			showImage(activeIndex);
		} else if (itemsMenu.length) {
			showImage(0);
		}

	}

	if(document.querySelector('.form-module-wrapper')){
		document.querySelectorAll('.form-module-wrapper').forEach((text) => {
			text.querySelector('.form-module').classList.add('animate-fade','top');
		});
	}

	if(document.querySelector('.text-modules-wrapper')){
		document.querySelectorAll('.text-modules-wrapper').forEach((text) => {
		text.querySelector('.text-modules').classList.add('animate-fade','top');
	});
	}

	if(document.querySelector('.global-sitemap')){
		document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
	}

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}


function initDualCards() {

    var dualCards = document.querySelectorAll('.dual-card');
    var dualWrapper = document.querySelector('.dual-wrapper');

    if (!dualCards.length || !dualWrapper) {
        return;
    }

    var activeCard = null;
    var isClicked = false;

    function openCard(card) {

        dualCards.forEach(function(item) {
            item.classList.remove('active');
        });

        card.classList.add('active');
        dualWrapper.classList.add('has-active');
        activeCard = card;
    }

    function closeCards() {

        dualCards.forEach(function(card) {
            card.classList.remove('active');
        });

        dualWrapper.classList.remove('has-active');
        activeCard = null;
    }

    dualCards.forEach(function(card) {

        card.addEventListener('mouseenter', function() {

            if (window.innerWidth <= 900) {
                return;
            }

            if (!isClicked) {
                openCard(card);
            }
        });
    });


    dualWrapper.addEventListener('mouseleave', function() {

        if (window.innerWidth <= 900) {
            return;
        }

        if (!isClicked) {
            closeCards();
        }
    });


    dualCards.forEach(function(card) {

        var trigger = card.querySelector('.dual-card__nav');

        if (!trigger) {
            return;
        }

        trigger.addEventListener('click', function(event) {

            event.preventDefault();
            event.stopPropagation();

            if (activeCard === card && isClicked) {
                closeCards();
                isClicked = false;
                return;
            }

            openCard(card);

            isClicked = true;
        });
    });

    document.addEventListener('click', function(event) {

        if (!event.target.closest('.dual-cards')) {
            closeCards();
            isClicked = false;
        }
    });

    window.addEventListener('resize', function() {

        if (window.innerWidth <= 900) {
            closeCards();
            isClicked = false;
        }
    });
}